export default __webpack_public_path__ + "static/media/google-adwords.01cd4ba9.svg";